import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";

function LinkButton({
  href,
  className,
  ref,
  onClick,
  children,
  variant,
  text,
  newWindow,
}) {
  const btnClass = classNames({
    [className]: true,
    btn: true,
    "btn--secondary": variant === "secondary",
  });
  return href ? (
    <Link
      to={href}
      className={btnClass}
      ref={ref}
      onClick={onClick}
      target={newWindow ? "_blank" : null}
    >
      {text}
      {children}
    </Link>
  ) : (
    <button type="button" className={btnClass} ref={ref} onClick={onClick}>
      {text}
      {children}
    </button>
  );
}

LinkButton.defaultProps = {
  href: null,
  className: null,
  ref: null,
  onClick: null,
  // eslint-disable-next-line react/forbid-prop-types
  children: null,
  variant: null,
  text: null,
};

LinkButton.propTypes = {
  href: PropTypes.string,
  className: PropTypes.string,
  ref: PropTypes.func,
  onClick: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any,
  variant: PropTypes.string,
  text: PropTypes.string,
};

export default LinkButton;
